import { render, staticRenderFns } from "./GerenciarUsuariosIcon.vue?vue&type=template&id=9e124b76"
import script from "./GerenciarUsuariosIcon.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuariosIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports